// File: src/components/DashboardLayout.tsx
// An improved layout where the content area scrolls independently.

import React from 'react';
import {Outlet} from 'react-router-dom';
import {Box} from '@mui/material';
import MainSidebar from '../MainSidebar';
// --- УДАЛЕНО: Импорт TopBar больше не нужен ---
// import TopBar from '../TopBar';

const DashboardLayout: React.FC = () => {
    return (
        <Box sx={{display: 'flex', minHeight: '100vh'}}>
            {/* Sidebar remains the same, fixed on the left */}
            <MainSidebar/>

            {/* Main wrapper for the rest of the content */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column', // Arrange TopBar and content vertically
                    flexGrow: 1,
                    width: 'calc(100% - 280px)' // Adjust 280px to your sidebar's width
                }}
            >
                {/* --- УДАЛЕНО: Компонент TopBar больше не рендерится --- */}

                {/*
                  This is the main content area. It will grow to fill the available space
                  and handle its own scrolling, leaving the TopBar unaffected.
                */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        // Add responsive padding for a better look on all screen sizes
                        p: {xs: 2, sm: 3, md: 4},
                        // Allows this area to scroll if content overflows
                        overflow: 'auto',
                    }}
                >
                    {/* The Outlet renders the page content here */}
                    <Outlet/>
                </Box>
            </Box>
        </Box>
    );
};

export default DashboardLayout;